import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import axiosInstance from "../../../app/axiosInstance";
import { handleApiError } from "../../common/utils/ErrorHandler";
import { prepareHeaders } from "../../auth/slice/AuthSlice";

export const downloadManual = createAsyncThunk(
  "download/downloadManual",
  async (_, { getState, rejectWithValue, dispatch }) => {
    try {
      const state = getState();
      const response = await axiosInstance.get(`/api/admin-manual-link`, {
        headers: prepareHeaders(state),
      });
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

const DownloadSlice = createSlice({
  name: "downloads",
  initialState: {
    loading: false,
    error: null,
    manualLink: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadManual.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadManual.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.manualLink = action.payload?.payload || "";
        }
      })
      .addCase(downloadManual.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default DownloadSlice.reducer;
